const styles = {
  tabs: { '& .MuiTabs-flexContainer': { flexWrap: 'wrap' } },
  indicatorTabs: { sx: { display: 'none' } },
};

export default styles;
